export default "/images/transfering-codes.svg?f9c40994f727a1cd4d9c1e3fcf7801f6";